/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Location } from '../../models/Locations/Locations';

export const selectAppLocation = (state: { appLocation: { value: Location | null } }) => state.appLocation.value;
export const selectActiveButtonIndex = (state: { appLocation: { index: number } }) => state.appLocation.index;
